import React from 'react'
import { useSelector } from 'react-redux'
import { actionCreators } from '@/store/outputReportGroupDefinitions'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'

import { useLocalization } from '@/hooks/localization'
import { useDispatch } from '@/hooks/dispatch'

import Resx from '@/components/Resx'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'
import { BooleanColumn, BsrsGrid, commandColumnProps } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { Button } from 'reactstrap'
import context from '@/context'
import Icon from '@/components/Icon'
import { TemplatesCell, templateCellExport } from '@/components/reporting/templatesCell'
import { useSignalR } from '@/hooks/useSignalR'

function OutputReportGroupDefinitions (props) {
  const { localize, localizeProps, locale, localizeValue } = useLocalization()

  const {
    gridComponentKey, isUpdating
  } = useSelector(state => {
    return {
      gridComponentKey: state.outputReportGroupDefinitions.gridComponentKey,
      isUpdating: state.outputReportGroupDefinitions.updating
    }
  })

  const [create, openDialog, setGridKey] =
  useDispatch([
    actionCreators.create,
    dialogActions.openDialog,
    actionCreators.setGridKey
  ])

  const openNewOuputReportGroupDefinitionDialog = () => {
    openDialog({
      dialogType: dialogTypes.addOutputReportGroup,
      onAction: (item) => create(item),
      localize: localize,
      localizeProps: localizeProps
    })
  }

  const templatesCell = (props) => <TemplatesCell {...props} locale={locale} localizeValue={localizeValue} />

  useSignalR('checkingBackGroundFinished', () => {
    setGridKey()
  }, [])

  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='Reporting.OutputReportGroupDefinitionsTitle' />
        </MainTopTitle>
        <MainTopLeft>
          <Button color='primary' disabled={isUpdating} className='btn-sm' onClick={openNewOuputReportGroupDefinitionDialog}>
            <Icon name={isUpdating ? 'loader bx-spin' : 'plus'} /> <span><Resx name='Reporting.AddOuputReportGroupButton' /></span>
          </Button>
        </MainTopLeft>
      </MainTop>
      <MainBody>
        <BsrsGrid
          persistenceId={'output-report-definitions'}
          dataSource={context.api.outputReportGroupDefinitionService.getTableData}
          lastReloadedAt={gridComponentKey}>
          <Column field='name' title={localize('Common.Name')} editable={false} />
          <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
          {BooleanColumn({ field: 'multipleInstitutions', title: localize('Reporting.MultipleInstitutions'), editable: true })}
          <Column field='templates' title={localize('Reporting.ReportingTemplates')} editable={false} sortable={false} filterable={false} cell={templatesCell} cellExport={templateCellExport} />
          <Column {...commandColumnProps({ detailUrl: x => `/output-report-definitions/${x.id}` })} />
        </BsrsGrid>
      </MainBody>
    </Main>
  )
}
export default OutputReportGroupDefinitions



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGroupDefinitions/index.js